
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(371|469|720|923)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
